exports.mosaic = 'mosaic-VSdifEw24r2rs+svf/fsXw==';
exports.cookie = 'cookie-csFe3s/sfdez0+svf/fsXw==';